module.exports = __webpack_public_path__ + "img/icon_flag_en.d759ed99.svg";